import GameMasterMapScene from "./GameMasterMapScene.tsx";
import GameMasterMapOverlays from "./GameMasterMapOverlays.tsx";
import {useGameMasterMapModel} from "./useGameMasterMapModel.ts";

export default function GameMasterMap() {
    const model = useGameMasterMapModel();
    return <div className="relative size-full">
        <GameMasterMapScene model={model}/>
        <GameMasterMapOverlays model={model}/>
    </div>;
}
